import { inject, Injectable } from '@angular/core';
import { LoginModalComponent } from '../app/login/login-modal.component';
import { MDBModalService } from 'ng-uikit-pro-standard';
import { LoginModalType } from '../models/enums/login-modal.enum';

@Injectable({ providedIn: 'root' })
export class LoginModalService {
  readonly #mdbModalService = inject(MDBModalService);

  public open(isRegister = false, description?: string): void {
    this.openLogin(isRegister ? LoginModalType.REGISTER : LoginModalType.LOGIN, description);
  }

  private openLogin(loginType: LoginModalType, description: string | undefined): void {
    const data = { loginType, description };
    const option = { class: '', data, ignoreBackdropClick: true };
    this.#mdbModalService.show(LoginModalComponent, option);
  }
}
